export enum CampaignType {
    CUSTOM = 'custom',
    RANDOM = 'random',
}

export enum CampaignStatus {
    IDLE = 'inactive',
    ACTIVE = 'active',
    EXPIRED = 'completed',
}

export enum ProjectPrefixes {
    MB = 'MB',
    WF = 'WF',
    YG = 'YG',
}

export interface CampaignItem {
    id: number;
    name: string;
    project_id: number;

    amount: number;
    discount: number;

    status: number;

    created_at?: string; // ISO timestamp
    updated_at?: string | null; // ISO timestamp or null
    created_by?: string;
    last_updated_by?: string | null;

    codes?: {
        items?: PromoCodeItem[];
        _meta: {
            page: number;
            per_page: number;
            total_pages: number;
            total_items: number;
        };
    };
}

export interface CampaignResponse {
    items: CampaignItem[];
    _meta: {
        page: number;
        per_page: number;
        total_pages: number;
        total_items: number;
    };
}

export interface CreateCampaignPayload {
    project_id: number;
    name: string;
    discount: number;
}

export interface GeneratePromoCodesPayload {
    project_id?: number;
    name?: string;
    discount?: number | null;
    prefix_pattern?: string;
    expires_at?: string;
    influencer_email?: string;
    amount: number | null;
    max_uses: number | null;
    usage_type: CampaignType;
}

export interface CampaignFormikValues {
    projectId: string;
    name: string;
    discount: number | null;
}

export interface PromoCodesFormikValues {
    projectId?: string;
    name?: string;
    discount?: number | null;
    prefix_pattern?: string;
    expires_at?: string;
    influencer_email?: string;
    amount: number | null;
    usage_count: number | null;
    type: CampaignType;
    status?: CampaignStatus;
}

export interface PromoCodeItem {
    code: string;
    code_metadata: Record<string, string>;
    created_at: string;
    discount: number;
    expired_at: string;
    id: number;
    project: string;
    provider_email?: string | null;
    provider_id: number;
    provider_name?: string | null;
    threshold: number;
    status: string;
    used_count?: number;
}
